/* eslint-disable react/prop-types */
import React from 'react'
import { Button, Container } from 'react-bootstrap'
import { useStaticQuery, graphql } from 'gatsby'
import { Swiper, SwiperSlide } from 'swiper/react'
import cn from 'classnames'

import { extractImageSrc } from '~utils/index'
import ItemBlog from './components/ItemBlog'

import * as s from './SectionBlog.module.scss'

const BLOG_QUERY = graphql`
  query {
    allFeedRss {
      nodes {
        title
        guid
        content {
          encoded
        }
      }
    }
  }
`

const SectionBlog = ({ id }) => {
  const { allFeedRss } = useStaticQuery(BLOG_QUERY)

  return (
    <section className={cn(s.sectionBlog, 'pt-20 mb-24')} id={id}>
      <Container>
        <h2 className={s.heading}>Latest From Us</h2>
        <div>
          <Swiper
            breakpoints={{
              375: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
          >
            {allFeedRss?.nodes?.map(({ guid, title, content }) => {
              const imageSrc = extractImageSrc(content.encoded)
              return (
                <SwiperSlide key={guid}>
                  <ItemBlog heading={title} image={imageSrc} link={guid} />
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>
        <div className={s.btnContainer}>
          <Button
            href="https://medium.com/xcademy"
            rel="nofollow noopener noreferrer"
            target="_blank"
            as="a"
            variant="outline-secondary"
            className={s.btnMedium}
          >
            <span className="link-external">View all on Medium</span>
          </Button>
        </div>
      </Container>
    </section>
  )
}

SectionBlog.defaultProps = {
  className: undefined,
}

export default SectionBlog
